import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-book-open-line text-background-50 text-lg"></i>
              </span>
              <span className="font-heading text-xl font-bold text-background-50">
                蜜桃少年漫画
              </span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed">
              178漫画网旗下少年漫画阅读平台，提供高清无删减漫画，免费下拉式阅读体验。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              热门分类
            </h4>
            <div className="flex flex-col gap-2">
              {['热血', '冒险', '搞笑', '奇幻', '恋爱', '悬疑'].map((cat) => (
                <Link
                  key={cat}
                  to={`/category/${cat === '热血' ? 'rexue' : cat === '冒险' ? 'maoxian' : cat === '搞笑' ? 'gaoxiao' : cat === '奇幻' ? 'qihuan' : cat === '恋爱' ? 'lianai' : 'xuanyi'}`}
                  className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer"
                >
                  {cat}漫画
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              快速链接
            </h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">
                首页
              </Link>
              <Link to="/about" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">
                关于我们
              </Link>
              <a href="#latest" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">
                最新更新
              </a>
              <a href="#popular" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer">
                人气排行
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              联系我们
            </h4>
            <div className="flex flex-col gap-2 text-sm text-background-400">
              <span className="flex items-center gap-2">
                <i className="ri-mail-line"></i>
                contact@sdidsa.cn
              </span>
              <span className="flex items-center gap-2">
                <i className="ri-customer-service-line"></i>
                在线客服：工作日 9:00-18:00
              </span>
              <span className="flex items-center gap-2">
                <i className="ri-map-pin-line"></i>
                中国·北京
              </span>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-background-800">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-sm text-background-500">
              &copy; {new Date().getFullYear()} 178漫画网 蜜桃少年漫画 版权所有
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-sm text-background-500 hover:text-background-300 transition-colors cursor-pointer" rel="nofollow">
                隐私政策
              </a>
              <a href="#" className="text-sm text-background-500 hover:text-background-300 transition-colors cursor-pointer" rel="nofollow">
                服务条款
              </a>
              <a href="#" className="text-sm text-background-500 hover:text-background-300 transition-colors cursor-pointer" rel="nofollow">
                版权声明
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}